import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Axios from 'axios';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

const handleLogin = async (event) => {
  event.preventDefault();

  // Validate email and password fields
  if (!email || !password) {
    setError('Please enter both email and password.');
    return;
  }

  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setError('Please enter a valid email address.');
    return;
  }

    try {
      const response = await Axios.post('https://dayoffice24.it/api/login', {
        email: email,
        password: password,
      });

      if (response.data.success) {
        localStorage.setItem('token', response.data.token);
        navigate('/Profile'); // Redirect to profile or dashboard
      } else {
        setError('Login failed. Please check your credentials.');
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('An error occurred. Please try again later.');
      }
    }
  };


  return (
    <div className="main_wrap">   
      <Header />
      <div className="content-wrapper">
        <section className="property-details-wrap pt-75 pb-75">
          <div className="container">
            <div className="row align-items-center login_bg gx-5">
              <div className="col-md-6">
                <div className="login-bg bg-f"></div>
              </div>
              <div className="col-md-6">
                <div className="login-content">
                  <h2>Sign In</h2>
                  <p>Don't have an account? <a href="/Register">Click here </a> to register now!</p>
                  <form className="user-form" onSubmit={handleLogin} action="#">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group"> 
                          <input 
                            id="text"
                            name="email"
                            type="text"
                            placeholder="Email"
                            required=""
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                          /> 
                        </div>
                      </div>
                      <div className="col-lg-12"> 
                        <div className="form-group">
                          <input
                            id="pwd"
                            name="pwd"
                            type="password"
                            placeholder="Password"
                            required=""
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-lg-12"> 
                        <div className="form-group">
                          <button className="btn style1">
                            Login
                          </button>
                        </div>
                      </div>
                      {error && (
                        <div className="col-lg-12">
                          <p className="text-danger">{error}</p>
                        </div>
                      )}
                      <Link to="/ForgotPassword">Forgot Password?</Link>
                      <div className="col-12">
                        <p className="text-center mb-10">Or</p>
                      </div>
                      <div className="col-12">
                        <p className="mb-0">Sign in with your social media account</p>
                      </div>
                      <div className="col-12">
                        <div className="social-icon">
                          <button type="button"><Link className="social" to="https://dayoffice24.it/auth/google/redirect"><i className="ri-google-fill"></i></Link></button>     
                         
                          <button type="button"><Link className="social" to="https://dayoffice24.it/auth/twitter/redirect"><i className="ri-twitter-fill"></i></Link></button>
                          <button type="button"><Link className="social" to="https://dayoffice24.it/auth/linkedin/redirect"><i class="ri-linkedin-fill"></i></Link></button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />  
    </div>
  );
};

export default Login;
